// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { boxStyles } from "@store/Themes/common/mixins/box";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";
import { css } from "styled-components";

export interface PasswordRequirementsPresentationProps extends ExpandStyles<PasswordRequirementsStyles> {}

export interface PasswordRequirementsProps extends PasswordRequirementsPresentationProps {}

export interface PasswordRequirementsStyles {
    wrapper?: InjectableCss;
    title?: TypographyProps;
    list?: InjectableCss;
    listItem?: InjectableCss;
}

const passwordRequirementsStyles: PasswordRequirementsStyles = {
    wrapper: {
        css: css`
            ${boxStyles()}

            ${breakpoint("md", "down")} {
                width: 100%;
            }
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
    },
};

const PasswordRequirements: FC<PasswordRequirementsProps> = ({ extendedStyles, overridedStyles }) => {
    const accountSettings = useSettingsCollection().accountSettings;
    const styles = useExpandProps(passwordRequirementsStyles, extendedStyles, overridedStyles);

    const {
        passwordMinimumLength,
        passwordRequiresUppercase,
        passwordRequiresSpecialCharacter,
        passwordRequiresLowercase,
        passwordRequiresDigit,
    } = accountSettings;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.title}>{translate("Password Requirements")}</Typography>
            <UnorderedList {...styles.list}>
                <ListItem {...styles.listItem}>
                    {translate("Password must be at least {0} characters long", passwordMinimumLength.toString())}
                </ListItem>
                {passwordRequiresDigit && (
                    <ListItem {...styles.listItem}>{translate("Password must include at least one number")}</ListItem>
                )}
                {passwordRequiresLowercase && (
                    <ListItem {...styles.listItem}>
                        {translate("Password must include at least one lowercase character")}
                    </ListItem>
                )}
                {passwordRequiresUppercase && (
                    <ListItem {...styles.listItem}>
                        {translate("Password must include at least one uppercase character")}
                    </ListItem>
                )}
                {passwordRequiresSpecialCharacter && (
                    <ListItem {...styles.listItem}>
                        {translate("Password must include at least one non alphanumeric character")}
                    </ListItem>
                )}
            </UnorderedList>
        </StyledWrapper>
    );
};

export default PasswordRequirements;
